import axiosConfig from "./axiosConfig";

class MemoireService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/memoires");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching memoires:", error);
      return [];
    }
  }

  async create(formData) {
    try {
      const response = await axiosConfig.post("/memoires", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la création:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async update(id, formData) {
    try {
      const response = await axiosConfig.put(`/memoires/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la mise à jour:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/memoires/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la suppression:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async download(id) {
    try {
      const response = await axiosConfig.get(`/memoires/${id}/fichier`, {
        responseType: "blob",
      });

      // Créer un URL pour le blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Créer un lien temporaire et déclencher le téléchargement
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", id);
      document.body.appendChild(link);
      link.click();

      // Nettoyer
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error("❌ Erreur lors du téléchargement:", error);
      return Promise.reject(error);
    }
  }
}

const MemoireServiceInstance = new MemoireService();
export default MemoireServiceInstance;
